module.exports = __webpack_public_path__ + "static/media/DLF.2c2896ad.txt";